import { GetListRes } from "../types/GetListRes";

export enum TableColumnKey {
  Operation = "operation",
  GroupSequence = "groupSequence",
  GroupName = "groupName",
  GroupType = "groupType",
  Status = "status",
  ChainName = "chainName",
  Currency = "currency",
  MaximumAmountLimit = "maximumAmountLimit",
  CreatedBy = "createdBy",
  CreationTime = "creationTime",
  LastModifiedTime = "lastModifiedTime",
  WalletDisplayName = "walletDisplayName",
  RiskType = "riskType",
  RecipientAddress = "recipientAddress",
  WalletType = "walletType",
  Rating = "rating",
  Probability = "probability",
}

export type TableRow = { [K in TableColumnKey]?: string } & {
  id: number;
  rawData?: GetListRes;
};
